import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { withRouter, Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { openModal, openRC, openMS, openAnn, openAnn2 } from "store/actions"
import AgendaModal from "../../pages/UIcomponents/AgendaModal"
import {
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Media,
  Row,
  Col,
  Modal,
} from "reactstrap"
import classnames from "classnames"
import parse from "html-react-parser"
import wicon1 from "../../assets/wicons/Icons-45.png"
import wicon2 from "../../assets/wicons/Icons-42.png"
import wicon3 from "../../assets/wicons/Vector-1.png"
import wicon4 from "../../assets/wicons/Icons-43.png"
import wicon5 from "../../assets/wicons/Icons-37.png"
import wicon6 from "../../assets/wicons/Icons-41.png"
import wicon7 from "../../assets/wicons/Icons-47.png"
import wicon8 from "../../assets/wicons/Icons-39.png"
import wicon9 from "../../assets/wicons/Icons-40.png"
import wicon10 from "../../assets/wicons/Icons-33.png"
import wicon11 from "../../assets/wicons/Icons-34.png"
import wicon12 from "../../assets/wicons/Icons-35.png"
import wicon13 from "../../assets/wicons/Icons-36.png"
import wicon14 from "../../assets/wicons/Vector-16.png"
import wicon15 from "../../assets/wicons/Icons-37.png"
import wicon16 from "../../assets/wicons/game.png"
import wicon17 from "../../assets/wicons/feedback.png"
import wicon18 from "../../assets/wicons/hospital.png"
import wicon19 from "../../assets/wicons/whiteticket.png"

import { BackpackStar, Blocks, ClipboardDetail, Crown, Discussion, Envelope, FilmRoll, Home, HomeAlt, HomeAlt2, HomeAlt3, Like, MessageBubbleQuestionMark, MessageDetail, MessageQuestionMark, MicrophoneAlt2, MicrophoneBigAlt, Poll, Task, UserIdCard, Video, Trip } from "@boxicons/react"

// var tawklink = ""
const getDataFromStorage = (key, fallback = {}) => {
  try {
    const str = localStorage.getItem(key)
    return str ? JSON.parse(str) : fallback
  } catch {
    return fallback
  }
}

const SidebarContent = props => {
  // LocalStorage reads with safety
  const Alldata = getDataFromStorage("dataJ")
  const authUser = getDataFromStorage("authUser")
  const [theAgenda, setTheAgenda] = useState(false)
  const [theFeedback, setTheFeedback] = useState(false)

  const agendaData = Alldata?.data?.agenda?.data || {}
  // Default to first agenda day if available
  const defaultTab = Object.values(agendaData)[0]?.name || ""
  const [ActiveTab, setActiveTab] = useState(defaultTab)

  const [modalQAVisible, setModalQAVisible] = useState(false)
  const [modalPreferenceVisible, setModalPreferenceVisible] = useState(false)
  const [helprc, setHelpRC] = useState(false)
  const [agendaModalOpen, setAgendaModalOpen] = useState(false)
  const [rs, setRS] = useState(false)
  const [rcc, setRCC] = useState("")
  const ref = useRef()

  const {
    modal,
    onOpenModal,
    rc,
    onOpenRC,
    ms,
    onOpenMS,
    ann,
    onOpenAnn,
    ann2,
    onOpenAnn2,
  } = props

  // Initialize MetisMenu
  useEffect(() => {
    const pathName = props.location.pathname
    new MetisMenu("#side-menu")
    // Highlight active menu item
    const ul = document.getElementById("side-menu")
    if (!ul) return
    const items = ul.getElementsByTagName("a")
    let matchingMenuItem = null
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) activateParentDropdown(matchingMenuItem)
    // eslint-disable-next-line
  }, [props.location.pathname])

  // Only recalculate scrollbar on relevant change
  useEffect(() => {
    if (ref.current && ref.current.recalculate) ref.current.recalculate()
  }, [ActiveTab, agendaData])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight && ref.current) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const toggleTheAgenda = () => {
    setTheAgenda(!theAgenda)
  }

  const toggleTheFeedback = () => {
    setTheFeedback(!theFeedback)
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    let parent = item.parentElement
    const addShow = el => el && el.classList.add("mm-show")
    const addActive = el => el && el.classList.add("mm-active")

    addActive(parent)
    let parent2 = parent?.parentElement
    addShow(parent2)

    let parent3 = parent2?.parentElement
    if (parent3) {
      addActive(parent3)
      addActive(parent3.childNodes[0])
      addShow(parent3.parentElement)
      let parent5 = parent3.parentElement?.parentElement
      if (parent5) {
        addShow(parent5)
        addActive(parent5.childNodes[0])
      }
    }
    scrollElement(item)
  }

  const toggleAgendaModal = () => setAgendaModalOpen(prev => !prev)
  const toggleCustom = tab => setActiveTab(tab)
  const togglers = () => setRS(prev => !prev)

  // Hardcoded URLs should come from config ideally, but kept here for simplicity
  let tawklink = ""
  Alldata?.data?.lobby?.data?.areas?.forEach(item => {
    if (item.id === "help") tawklink = item.url || ""
  })

const toggleOpenPdf = async pdf => {
    try {
      await loadPDF(`https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FInfobooth.pdf?alt=media&token=f4c22409-0089-4b5b-9b1e-83df0b39ee04`)
      onOpenAnn2()
    } catch (error) {
      console.error("Error loading the PDF:", error)
    }
  }

  return (
    <React.Fragment>
      {/* Agenda modal */}
      <AgendaModal isOpen={agendaModalOpen} toggle={toggleAgendaModal} /> 

      {/* The Agenda  */}
      {/* <Modal
        size="xl"
        isOpen={theAgenda}
        toggle={toggleTheAgenda}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Agenda</h5>
          <button
            type="button"
            onClick={() => {
              setTheAgenda(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="500px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Xcelerate%2FAgenda.pdf?alt=media&token=22735e62-6bc5-4938-bf42-8a76852d0e4e"
          />
        </div>
      </Modal> */}

      <Modal
        size="xl"
        isOpen={theAgenda}
        toggle={toggleTheAgenda}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0"></h5>
          <button
            type="button"
            onClick={() => setTheAgenda(false)}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div style={{ width: "100%", height: "100%" }} id="pdf-container">
            <iframe
              src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FInfobooth.pdf?alt=media&token=f4c22409-0089-4b5b-9b1e-83df0b39ee04"
              width="100%"
              height="550px"
              style={{ border: "none" }}
            />
          </div>
        </div>
      </Modal>

      {/* The Feedback  */}
      <Modal
        size="lg"
        isOpen={theFeedback}
        toggle={toggleTheFeedback}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Poll Questions</h5>
          <button
            type="button"
            onClick={() => {
              setTheFeedback(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="500px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src="https://app.sli.do/event/6JWMYzD5nqdd1voEb8SSUG"
          />
        </div>
      </Modal>

      {/* Infobooth */}
                      {/* <Modal
                        size="xl"
                        isOpen={ann2}
                        toggle={onOpenAnn2}
                        centered={true}
                        style={{ width: "auto" }}
                      >
                        <div className="modal-header">
                          <h5 className="modal-title mt-0"></h5>
                          <button
                            type="button"
                            onClick={onOpenAnn2}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div
                            style={{ width: "100%", height: "100%" }}
                            id="pdf-container"
                          ></div>
                        </div>
                      </Modal> */}

      {/* Opening Soon Modal */}
      <Modal isOpen={rs} toggle={togglers} centered style={{ width: "auto" }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Opening Soon!</h5>
          <button
            type="button"
            onClick={togglers}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body" style={{ color: "#00A982" }}>
          {rcc}
        </div>
      </Modal>

      {/* Agenda Modal (XL) */}
      <Modal size="xl" isOpen={modal} toggle={onOpenModal} centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myExtraLargeModalLabel">
            Agenda
          </h5>
          <button
            onClick={onOpenModal}
            type="button"
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <Nav tabs className="nav-tabs-custom nav-justified">
                {Object.entries(agendaData).map(([k, day]) => (
                  <NavItem key={day.name}>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: ActiveTab === day.name })}
                      onClick={() => toggleCustom(day.name)}
                    >
                      <span>{day.name}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              <TabContent activeTab={ActiveTab} className="p-3 text-muted">
                {Object.entries(agendaData).map(([k, day]) => (
                  <TabPane key={day.name} tabId={day.name}>
                    {(day.data || []).map((cardo, idc) => (
                      <Row key={cardo.id || `${day.name}-${idc}`}>
                        <Col sm="12">
                          <Card>
                            <CardBody>
                              <Media>
                                <Media body className="align-self-center">
                                  {cardo.redirect && (
                                    <a href={cardo.redirect}>
                                      <button
                                        className="btn btn-danger"
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                        }}
                                      >
                                        {cardo.btnText || "Join"}
                                      </button>
                                    </a>
                                  )}
                                  <div className="text-muted">
                                    <h5>{cardo.title}</h5>
                                    <h6>{cardo.time}</h6>
                                    {cardo.des && (
                                      <p className="mb-1">
                                        {parse(String(cardo.des))}
                                      </p>
                                    )}
                                  </div>
                                </Media>
                              </Media>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    ))}
                  </TabPane>
                ))}
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </Modal>

      {/* Helpdesk Modal */}
      <Modal
        isOpen={helprc}
        toggle={() => setHelpRC(prev => !prev)}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Help Desk</h5>
          <button
            type="button"
            onClick={() => setHelpRC(prev => !prev)}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="450px"
            width="100%"
            title="Help Desk"
            className="embed-responsive-item"
            src={encodeURI(tawklink)}
          />
        </div>
      </Modal>

      {/* Feedback Polls modal */}
      <Modal
        size="lg"
        isOpen={modalQAVisible}
        toggle={() => setModalQAVisible(prev => !prev)}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Feedback Polls</h5>
          <button
            type="button"
            onClick={() => setModalQAVisible(false)}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="500px"
            width="100%"
            title="Feedback Polls"
            className="embed-responsive-item"
            src="https://app.sli.do/event/74BpiUVJsmME5t6E2hgwy6"
          />
        </div>
      </Modal>

      {/* Photo Gallery modal */}
      <Modal
        size="xl"
        isOpen={modalPreferenceVisible}
        toggle={() => setModalPreferenceVisible(prev => !prev)}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Gallery</h5>
          <button
            type="button"
            onClick={() => setModalPreferenceVisible(false)}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            height="475px"
            width="100%"
            title="Photo Gallery"
            allowFullScreen
            className="embed-responsive-item"
            src="https://eventphotobooth.nyuctech.in/dashboard/feed"
          />
        </div>
      </Modal>

      {/* SIDEBAR MENU */}
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("EASY NAVIGATION")}</li>
            <li>
              <Link className="lnk" to="/page/lobby">
                {/* <i className="bx bx-home-circle "></i> */}
                {/* <i class="bx bx-home bx-wiggle" /> */}
                {/* <Home /> */}
                {/* <Home pack="filled" /> */}
                <HomeAlt pack="filled" />
                {/* <img className="wicon" src={wicon1} /> */}
                <span style={{paddingLeft: "10px"}}>{props.t("Home")}</span>
              </Link>
            </li>
            {/* Add more menu links as needed using <Link> and using modal toggles for functional entries */}

            <li className="menu-title">{props.t("INFORMATION")}</li>

            <li>
              <a
                onClick={e => {
                  e.preventDefault()
                  toggleAgendaModal()
                }}
                role="button"
                tabIndex={0}
              >
                {/* <i className="bx bx-calendar-event "></i> */}
                {/* <img className="wicon" src={wicon2} /> */}
                {/* <i className="bx bx-clipboard" /> */}
                <ClipboardDetail pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Agenda")}</span>
              </a>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/page/speaker">
              {/* <Link to="/Carousel"> */}
                {/* <img className="wicon" src={wicon12} /> */}
                <MicrophoneAlt2 pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Speakers")}</span>
              </Link>
            </li>

            <li>
              <Link to="/map" className="">
                <Trip pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Indoor Maps")}</span>
              </Link>
            </li>

            <li onClick={onOpenRC}>
              <a>
                {/* <i className="bx bxs-videos"></i> */}
                {/* <img className="wicon" src={wicon6}/> */}
                <Video pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Video Library")}</span>
              </a>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/page/blogs" className="">
                {/* <i className="bx bxs-photo-album "></i> */}
                {/* <img className="wicon" src={wicon11}/> */}
                <MessageDetail pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Blogs")}</span>
              </Link>
            </li>

            <li>
              <Link to="/page/faq" className="">
                {/* <i className="bx bxs-bell-ring"></i>  */}
                {/* <img className="wicon" src={wicon13} /> */}
                <Discussion pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("FAQ")}</span>
              </Link>
            </li>

            <li>
              <Link to="/page/contactus" className="">
                {/* <i className="bx bxs-book-content"></i> */}
                {/* <img className="wicon" src={wicon9} /> */}
                <Envelope pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Contact Us")}</span>
              </Link>
            </li>






            <li className="menu-title">{props.t("Engagement")}</li>






            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/page/livepolls" className="">
                {/* <i className="bx bx-poll"></i> */}
                {/* <img className="wicon" src={wicon3}/> */}
                <Poll pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Live Polls")}</span>
              </Link>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
                <Link to="/quiz" className="">
                <Task pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Quiz")}</span>
              </Link>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/page/Q&A" className="">
                {/* <i className="bx bxs-photo-album "></i> */}
                {/* <img className="wicon" src={wicon13}/> */}
                <MessageBubbleQuestionMark pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Q&A")}</span>
              </Link>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/leaderboard" className="">
                <Crown pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Leaderboard")}</span>
              </Link>
            </li>

            <li>
             <Link to="/walmartAnalysis" className="">
              {/* <Link to="/wrappedBadge" className=""> */}
                <Blocks pack="filled" removePadding/>
                <span style={{paddingLeft: "10px"}}>{props.t("Converge Checkout")}</span>
              </Link>
            </li>

            <li>
              {/* <Link to="/page/comingsoon"> */}
              <Link to="/feedback" className="">
                <Like pack="filled" />
                <span style={{paddingLeft: "10px"}}>{props.t("Feedback")}</span>
              </Link>
            </li>

            {/* <li>
              <a
                onClick={e => {
                  e.preventDefault()
                  onOpenAnn()
                }}
                role="button"
                tabIndex={0}
              >
                <i className="bx bxs-bell-ring"></i>
                <img className="wicon" src={wicon7}/>
                <span>{props.t("Push Notification")}</span>
              </a>
            </li> */}

            {/* <li
              onClick={async () => {
                const pdfAgendaUrls =
                  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Xcelerate%2FAgenda.pdf?alt=media&token=22735e62-6bc5-4938-bf42-8a76852d0e4e"

                await loadPDF(pdfAgendaUrls)
                onOpenAnn2()
              }}
            >
              <a>
                <i class="bx bxs-book-content"></i>
                <span>{props.t("Agenda")}</span>
              </a>
            </li> */}

            {/* <li>
              <Link to="/page/Agenda1" className="">
                <i className="bx bx-calendar-event"></i>
                <img className="wicon" src={wicon3} />
                <span>{props.t("Agenda")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/resources" className="">
                <i className="bx bx-poll"></i>
                <img className="wicon" src={wicon3} />
                <span>{props.t("Resources")}</span>
              </Link>
            </li> */}

            

            {/* <li>
              <Link to="/page/infobooth" className="">
                <i className="bx bxs-book-content"></i>
                <img className="wicon" src={wicon10} />
                <span>{props.t("Infobooth")}</span>
              </Link>
            </li> */}

            {/* <li onClick={toggleOpenPdf}>
              <a to="#" className="">
                <img className="wicon" src={wicon10} />
                <span>{props.t("Infobooth")}</span>
              </a>
            </li> */}

            {/* <li onClick={onOpenRC}>
              <a>
                <i className="bx bxs-videos"></i>
                <img className="wicon" src={wicon6} />
                <span>{props.t("Video Library")}</span>
              </a>
            </li> */}
            {/* <li>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault()
                  onOpenAnn()
                }}
                role="button"
                tabIndex={0}
              >
                <i className="bx bxs-bell-ring"></i>
                <img className="wicon" src={wicon7} />
                <span>{props.t("Push Notification")}</span>
              </a>
            </li> */}

            

            {/* <li>
              <Link to="/activityfeed" className="">
                <i className="bx bxs-book-content"></i>
                <img className="wicon" src={wicon15} />
                <span>{props.t("Activity Feed")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/comingsoon1">
                <Link to="/page/quiz" className="">
                <i className="bx bx-poll"></i>
                <img className="wicon" src={wicon4} />
                <span>{props.t("Quiz")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/games" className="">
              <Link to="/page/comingsoon2">
                <i className="bx bxs-photo-album "></i>
                <img className="wicon" src={wicon16} />
                <span>{props.t("Games")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/findmypicture" className="">
                <i className="bx bxs-photo-album "></i>
                <img className="wicon" src={wicon16} />
                <span>{props.t("Find My Picture")}</span>
              </Link>
            </li> */}

            {/* <li>
              <a
                href="https://www.kwikpic.in/auth/login?uCode=RGP9PQ&adminToken=RGP9PQnT6aGWnQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxs-photo-album "></i>
                <span>{props.t("Find My Picture")}</span>
              </a>
            </li> */}

            {/* <li>
              <Link to="/inventory" className="">
                
                <BackpackStar pack="filled" removePadding/>
                <span style={{paddingLeft: "10px"}}>{props.t("Your Inventory")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/userbadge" className="">
                <UserIdCard pack="filled" removePadding />
                <span style={{paddingLeft: "10px"}}>{props.t("Your Badge")}</span>
              </Link>
            </li> */}

            

            

            

            {/* <li>
              <Link to="/flighttickets" className="">
                <i className="bx bxs-book-content"></i>
                <img className="wicon" src={wicon19} />
                <span>{props.t("Ticket")}</span>
              </Link>
            </li> */}

             

            

            

            {/* <li>
              <a
                href={`http://127.0.0.1:5500/game/index.html?id=sanket@nyuctech.com&admin=http://localhost:9000/submitscore&platform=http://localhost:3000/leaderboard`}
                href= {'https://tictactoe-xcelerate.d1e9yji7byqstm.amplifyapp.com?id='}
                target="_blank"
                className=""
              >
                <i className="bx bx-book-add"></i>
                <span>{props.t("tic tac toe")}</span>
              </a>
            </li> */}

            {/* <li>
              <a
                href="https://facialrecognition.algomage.com/facerec/omsi-15th-annual-day"
                target="_blank"
                rel="noopener noreferrer"
              >
              <Link to="/page/photogallery">
                <i className="bx bxs-photo-album "></i>
                <span>{props.t("Photo Gallery")}</span>
              </Link>
              </a>
            </li> */}
            {/* <li>
              <a
                href="https://player.vimeo.com/video/1014311963?"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxs-videos"></i>
                <span>{props.t("Video Gallery")}</span>
              </a>
            </li> */}

            {/* <li>
              <Link to="/page/speaker" className="">
                <i className="bx bxs-book-content"></i>
                <img className="wicon" src={wicon12} />
                <span>{props.t("Speakers")}</span>
              </Link>
            </li> */}

            

            

            {/* <li>
              <Link to="/weather" className="">
                <i className="bx bxs-cloud"></i>
                <img className="wicon" src={wicon17} />
                <span>{props.t("Weather Forecast")}</span>
              </Link>
            </li> */}

            {/* <li onClick={toggleTheFeedback}>
            <li>
                <a to="#" className="">
                <i className="bx bx-poll"></i>
                <img className="wicon" src={wicon17} />
                <span>{props.t("Poll Questions")}</span>
                </a>
            </li> */}

            {/* <li>
              <Link to="/page/medical" className="">
                <i className="bx bxs-photo-album "></i>
                <img className="wicon" src={wicon18} />
                <span>{props.t("Medical Assistance")}</span>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/page/infobooth" className="">
                <i className="bx bxs-photo-album "></i>
                <img className="wicon" src={wicon13} />
                <span>{props.t("Q & A")}</span>
              </Link>
            </li> */}

            {/* <li>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault()
                  setModalQAVisible(true)
                }}
                role="button"
                tabIndex={0}
              >
                <i className="bx bx-dice-6"></i>
                <img className="wicon" src={wicon17} />
                <span>{props.t("Feedback")}</span>
              </a>
            </li> */}

            
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  modal: PropTypes.any,
  rc: PropTypes.any,
  ann2: PropTypes.any,
  location: PropTypes.object,
  t: PropTypes.any,
  onOpenModal: PropTypes.any,
  onOpenRC: PropTypes.any,
  onOpenAnn: PropTypes.any,
  onOpenAnn2: PropTypes.any,
}

const mapStateToProps = ({ agenda }) => ({
  modal: agenda.modal,
  rc: agenda.rc,
  ms: agenda.ms,
  ann: agenda.ann,
  ann2: agenda.ann2,
})

const mapDispatchToProps = dispatch => ({
  onOpenModal: () => dispatch(openModal()),
  onOpenRC: () => dispatch(openRC()),
  onOpenMS: () => dispatch(openMS()),
  onOpenAnn: () => dispatch(openAnn()),
  onOpenAnn2: () => dispatch(openAnn2()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(SidebarContent)))
